// Browsers can refuse storage access altogether (blocked site data, some
// private modes): merely touching window.localStorage then throws. The app has
// to keep working in memory in that case, so every access goes through here.
// A failed read answers null, a failed write returns false and is logged.
const createSafeStorage = kind => {
	const run = (action, fallback, fn) => {
		try {
			return fn(window[kind])
		} catch (error) {
			console.error(`${kind}.${action} failed`, error)
			return fallback
		}
	}

	return {
		getItem: key => run('getItem', null, storage => storage.getItem(key)),
		setItem: (key, value) =>
			run('setItem', false, storage => {
				storage.setItem(key, value)
				return true
			}),
		removeItem: key => run('removeItem', undefined, storage => storage.removeItem(key)),
		clear: () => run('clear', undefined, storage => storage.clear()),
	}
}

export const safeLocalStorage = createSafeStorage('localStorage')
export const safeSessionStorage = createSafeStorage('sessionStorage')
